import { injectable, IPageDefine, LocationInfo } from '@meego-remote/core/app/contract';
import { DetailPageKey, DetailPageParams } from '../contract';

export interface DetailPageParam {
  simpleName: string;
  workItemType: string;
  workItemID: string;
}

@injectable({ implements: [IPageDefine] })
export class DetailPageDefine implements IPageDefine<DetailPageParams> {
  key = DetailPageKey;
  pathPattern = ['/:simpleName/:workItemType/detail/:workItemID'];
  excludedPathPattern?: string[] | undefined;
  parseParams(loc: LocationInfo, matchPattern: string, queryParam: Record<string, any>) {
    return queryParam as DetailPageParams;
  }
}
